import { useRootContext } from "context/app-context";
import React from "react";
import { Image } from "react-bootstrap";
import {
  formatNumberValue,
  handleKeyDown,
  twoDecimalPlaces,
} from "utils/helper";

const InputField = ({
  className,
  coinName,
  inputTitle,
  coinImage,
  inputValue,
  accountImg,
  accountName,
  handleChange,
  setInputValue,
  userTokenBalance,
  approvalAllowance,
}) => {
  const { isSignWallet } = useRootContext();

  return (
    <div className={`customInputField ${className}`}>
      <div className="top">
        <div className="left">
          {inputTitle && (
            <div className="inputHeading">
              <div className="name">{inputTitle}</div>
              <div className="account-tag">
                <Image src={accountImg} />
                {accountName}
              </div>
            </div>
          )}
          <input
            type="number"
            id="inputVal"
            placeholder="0"
            name="amount"
            autoComplete="off"
            className="amount"
            value={inputValue}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="right swapWith">
          {coinName && (
            <div className="walletLogo">
              <span className="wallet">
                <Image src={coinImage} fluid />
              </span>
              <span className="walletName">{coinName}</span>
            </div>
          )}
        </div>
      </div>
      {isSignWallet && (
        <div className="bottom">
          <div className="left">
            <div className="balanceChain">
              <span className="chainName">
                Balance: {twoDecimalPlaces(userTokenBalance)}
              </span>
            </div>
            {approvalAllowance > 0 && (
              <div className="approvedBalance">
                <span className="chainName">
                  You have {formatNumberValue(approvalAllowance)} approved TVK
                </span>
              </div>
            )}
          </div>
          <div
            className="right"
            onClick={() => {
              userTokenBalance > 0 && setInputValue(userTokenBalance);
            }}
          >
            <div
              className="tag"
              style={{
                pointerEvents: userTokenBalance > 0 ? "auto" : "none",
                cursor: "pointer",
              }}
            >
              Max
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InputField;
